// Dependencies
import React from 'react';
import { useLocation, Link } from 'react-router';

// Material
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// Utils
import { toTitleCase } from 'utils/formatters';

// note: if you want more friendly names in the breadcrumbs,
// see breadcrumbNameMap in https://mui.com/components/breadcrumbs/#integration-with-react-router

function BreadcrumbCommon() {
	let { pathname } = useLocation();
	let pathnames = pathname.split('/').filter((x) => x);
	// optional: remove numbered paths (resource id's)
	// note: remove/change below as per app requirements
	// pathnames = pathnames.filter(x => isNaN(x));

	return (
		<Stack spacing={2}>
			<Breadcrumbs
				aria-label="Breadcrumb"
				separator={<NavigateNextIcon fontSize="small" />}
			>
				<Link color="inherit" to="/">
					Home
				</Link>

				{/* Renders path segments */}
				{pathnames.map((value, index) => {
					const last = index === pathnames.length - 1;
					const to = `/${pathnames.slice(0, index + 1).join('/')}`;

					return last ? (
						<Typography key={to} color="textPrimary" >
							{toTitleCase(value)}
						</Typography>
					) : (
						<Link key={to} color="inherit" to={to}>
							{toTitleCase(value)}
						</Link>
					);
				})}
			</Breadcrumbs>
		</Stack>
	);
}

export { BreadcrumbCommon };
